import i18n from "i18next";
import resources from "../utils/translation";

i18n.init({
  resources,
  lng: "bm",
});
